module.exports = __webpack_public_path__ + "static/media/xYELD.ca29c755.svg";